import type { PSDTemplate } from "../../../../../../models/MockupConfig/index";

export type MockupSize = "large" | "medium" | "small";

export function sortPsdTemplates(
  templates: PSDTemplate[],
  placementTypes: { id: number; sort_order?: number }[],
) {
  return [...templates].sort((a, b) => {
    const ptA = placementTypes.find((pt) => pt.id === (a.placement_type_id ?? 0));
    const ptB = placementTypes.find((pt) => pt.id === (b.placement_type_id ?? 0));
    const orderA = ptA?.sort_order ?? 99;
    const orderB = ptB?.sort_order ?? 99;
    if (orderA !== orderB) return orderA - orderB;
    return (a.view_angle ?? "").localeCompare(b.view_angle ?? "");
  });
}

export function pickPreferredMockupSize(): MockupSize {
  const conn = (navigator as Navigator & { connection?: { effectiveType?: string } })
    ?.connection;
  const effectiveType = conn?.effectiveType;
  if (effectiveType === "4g") return "large";
  if (effectiveType === "3g") return "medium";
  if (effectiveType === "2g" || effectiveType === "slow-2g") return "small";
  return "medium";
}

export function deriveMockupOutputsFromStoredUrl(url: string): {
  large: string;
  medium: string;
  small: string;
} {
  const match = url.match(/\/(large|medium|small)\.webp$/i);
  if (!match) return { large: url, medium: url, small: url };
  const base = url.replace(/\/(large|medium|small)\.webp$/i, "");
  return {
    large: `${base}/large.webp`,
    medium: `${base}/medium.webp`,
    small: `${base}/small.webp`,
  };
}

export function downloadMockupAsset(url: string, filename: string) {
  const directLink = document.createElement("a");
  directLink.href = url;
  directLink.download = filename;
  directLink.target = "_blank";
  directLink.rel = "noopener noreferrer";
  directLink.style.display = "none";
  document.body.appendChild(directLink);
  directLink.click();
  directLink.remove();
}
